// extracted by mini-css-extract-plugin
export default {"title-section":"hP1ivV3V5G","titleSection":"hP1ivV3V5G"};
    if(module.hot) {
      // 1627035574936
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  